import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { certificateService, CertificatePage } from './certificate-service'
import { toast } from 'sonner'

export const useCertificatePage = () => {
    const queryClient = useQueryClient()

    const certificatePageQuery = useQuery({
        queryKey: ['certificate-page'],
        queryFn: certificateService.getCertificatePage
    })

    const updateCertificatePageMutation = useMutation({
        mutationFn: ({ data, translate }: { data: Partial<CertificatePage>; translate?: boolean }) =>
            certificateService.updateCertificatePage(data, translate),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['certificate-page'] })
            toast.success('Sertifika sayfası başarıyla güncellendi.')
        },
        onError: (error: any) => {
            toast.error('Sertifika sayfası güncellenirken bir hata oluştu: ' + error.message)
        }
    })

    return {
        certificatePageQuery,
        updateCertificatePageMutation
    }
}
